/** Sales Engagement permission keys from GET /permission/get/:role_id. */
export const SALES_ENGAGEMENT_PERMISSION_KEYS = {
  /** DB spelling (no second "e"). */
  SUBMIT_ENGAGEMENT_FORM: "engagment_form_submission",
  MANAGE_ENGAGEMENTS: "manage_engagement",
} as const;

export type SalesEngagementPermissionKey =
  (typeof SALES_ENGAGEMENT_PERMISSION_KEYS)[keyof typeof SALES_ENGAGEMENT_PERMISSION_KEYS];
